import { AfterViewInit, Component } from '@angular/core';
import { QrPrintPayload, User } from '@app/state/app-state/interfaces';
import { getQrCodesPayloadToPrint } from '@app/state/app-state/selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Ping } from './state/app-state/actions';

@Component({
  selector: 'kody-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    class: 'w-100 h-100 justify-content-center',
  },
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  users$: Observable<User[]>;
  qrPrintPayload: Observable<QrPrintPayload> = this.store.select(getQrCodesPayloadToPrint);

  constructor(private store: Store) {}

  ngAfterViewInit(): void {
    this.store.dispatch(Ping());
  }
}
